module.exports = __webpack_public_path__ + "static/media/18.dbfd20a4.jpeg";